import { useMemo } from "react";
import { AgGridReact } from "@jsq/ds/core";

export const useCanopyRolesTableAgGridOptions = () => {
  const colDefs: AgGridReact.AgGridReactProps["columnDefs"] = useMemo(() => {
    return [
      {
        field: "title",
        headerName: "Role",
        filter: "agTextColumnFilter",
      },
      {
        field: "memberCount",
        headerName: "Assigned users",
        filter: "agNumberColumnFilter",
      },
    ];
  }, []);

  return { colDefs };
};
